import React from 'react'

// Services
import VendorServices from 'Services/Api/MasterData/vendor'
import ProjectsServices from 'Services/Api/MasterData/project'
import GLAccountServices from 'Services/Api/MasterData/glAccount'
import AdvanceProjectClass from 'Services/Api/ProjectClass/projectClass'
import TransactionServices from 'Services/Api/NonPOItem/nonPOItem'
import ItemNumberServices from 'Services/Api/MasterData/itemNumber'
import GLAccountFunctionsServices from 'Services/Api/GLAccounts/glAccounts'

export default function OnChange(args) {
  const {
    event,
    isSuggestionClick,
    index,
    name,
    isProjectClass = false,
    params,
    setSuggestionsWtaxRate,
    setSuggestionsVatType,
    setSuggestion,
    suggestion,
    handleOnComputation,
    setValue,
    value
  } = args
  if (isProjectClass) {
    let projectClass = [...value.projectClass]
    projectClass[parseInt(index)][name] = event
    setValue({ ...value, projectClass: projectClass })
    if (isSuggestionClick) {
      for (let i of suggestion) {
        if (event === i) {
          setValue({ ...value, projectClass: projectClass })
        }
      }
    }
    handleOnComputation()
    let _params = {
      sort: 1,
      ...params
    }
    _params.search = event ? event : toString(event)
    switch (name) {
      case 'glAccount':
        const parameter = value.projectClass[index].glCategory
        GLAccountFunctionsServices.getGLAccountsByCategory(parameter, _params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(`${items.accountCode} ${items.accountName}`)
          })
          setSuggestion(newData)
        })
        break
      case 'projectClass':
        AdvanceProjectClass.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items)
          })
          setSuggestion(newData)
        })
        break
      case 'itemNumber':
        ItemNumberServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.itemNo)
          })
          setSuggestion(newData)
        })
        break
    }
  } else {
    setValue({ ...value, [name]: event })
    if (isSuggestionClick) {
      suggestion.map(i => {
        if (event === i) {
          setValue({ ...value, [name]: event })
        }
      })
    }
    let _params = {
      sort: 1,
      ...params
    }
    _params.search = event ? event : toString(event)
    switch (name) {
      case 'project':
        ProjectsServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.projectName)
          })
          setSuggestion(newData)
        })
        break
      case 'vendor':
        TransactionServices.getVendorMapping(_params).then(res => {
          const data = res.data.data
            
          const vendor = []
          const taxRate = []
          data.vendor.map(items => {
            vendor.push(items.bpName)
          })
          if (data.wTaxRate.length <= 0) {
            taxRate.push('X1 (None)')
          } else {
            data.wTaxRate.map(items => {
              taxRate.push(`${items.wTaxCode} ${items.wTaxDisplayName}`)
            })
          }

          const vatType = []
          data.vatType.map(items => {
            vatType.push(items === 'IVAT-S' ? 'Services IVAT-S' : items === 'IVAT-G' ? 'Goods IVAT-G' : 'None IVAT-X1')
          })
          setSuggestionsVatType(vatType)
          setSuggestionsWtaxRate(taxRate)
          setSuggestion(vendor)
        })
        break
    }
  }
}
